export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/drums.ea4f436.svg";